var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9351 91.1511C70.9712 91.1511 91.267 70.8554 91.267 45.8192C91.267 20.7831 70.9712 0.487305 45.9351 0.487305C20.8989 0.487305 0.603149 20.7831 0.603149 45.8192C0.603149 70.8554 20.8989 91.1511 45.9351 91.1511Z",
    fill: "#662121"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M25.3464 69.3889H14.3534L34.3928 18.6536C36.5069 13.3268 40.3971 11.2972 46.3998 11.2972C52.4025 11.2972 56.2082 13.3268 58.2378 18.6536L77.5167 69.3889H66.4392L49.1054 23.4733C48.5984 22.1197 47.6673 21.5282 46.3153 21.5282C44.9633 21.5282 44.0322 22.1197 43.4407 23.4733L25.3448 69.3889H25.3464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0735 51.2586H8.54474L13.1532 39.5912C13.6399 38.3659 14.5334 37.8996 15.9151 37.8996C17.2969 37.8996 18.1716 38.3659 18.638 39.5912L23.0712 51.2586H20.5236L16.5364 40.6991C16.419 40.3877 16.2062 40.2515 15.8948 40.2515C15.5834 40.2515 15.369 40.3877 15.2329 40.6991L11.072 51.2586H11.0735Z",
    fill: "url(#paint0_linear_178_485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8331 38.1327V46.9021C25.8331 48.2056 26.495 48.963 28.0114 48.963H30.3446C31.8218 48.963 32.5025 48.204 32.5025 46.9021V38.1327H34.759V47.0774C34.759 49.8393 33.3005 51.2586 30.501 51.2586H27.7391C24.9396 51.2586 23.4999 49.8393 23.4999 47.0774V38.1327H25.8331Z",
    fill: "url(#paint1_linear_178_485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2482 38.1327C47.2042 38.1327 48.4686 39.9605 48.4686 42.0605C48.4686 43.6942 47.6908 45.4437 45.6878 46.0086L48.7409 51.2586H46.1933L43.1982 46.1838H39.7759C39.5615 46.1838 39.4457 46.2809 39.4457 46.514V51.2586H37.1516V46.0665C37.1516 44.5893 37.7744 43.9852 39.2125 43.9852H44.3264C45.6299 43.9852 46.1542 43.0901 46.1542 42.1575C46.1542 41.2248 45.5908 40.4268 44.3264 40.4268H37.1313V38.1327H44.2482Z",
    fill: "url(#paint2_linear_178_485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3384 38.1327V46.9021C52.3384 48.2056 53.0004 48.963 54.5167 48.963H56.8499C58.3271 48.963 59.0078 48.204 59.0078 46.9021V38.1327H61.2643V47.0774C61.2643 49.8393 59.8059 51.2586 57.0064 51.2586H54.2444C51.4449 51.2586 50.0052 49.8393 50.0052 47.0774V38.1327H52.3384Z",
    fill: "url(#paint3_linear_178_485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.142 51.2586H61.6915L65.7554 40.3298C66.2608 38.8322 67.0964 37.8996 68.8475 37.8996C70.7926 37.8996 71.7644 39.0466 71.7644 40.7585V48.517C71.7644 48.9646 72.0366 49.2556 72.4263 49.2556C72.7768 49.2556 73.0491 49.0412 73.1649 48.7111L76.354 40.3298C76.8595 38.8322 77.6951 37.8996 79.4462 37.8996C81.3913 37.8996 82.363 39.0466 82.363 40.7585V51.2602H80.0486V40.8759C80.0486 40.4096 79.7763 40.1169 79.3867 40.1169C79.0565 40.1169 78.7842 40.3501 78.6669 40.6803L75.4777 49.0616C74.9723 50.5591 74.1163 51.4918 72.3668 51.4918C70.4421 51.4918 69.4687 50.3448 69.4687 48.614V40.8743C69.4687 40.408 69.1777 40.1154 68.788 40.1154C68.4375 40.1154 68.2043 40.3485 68.0682 40.6787L64.1404 51.2571L64.142 51.2586Z",
    fill: "url(#paint4_linear_178_485)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_485",
    x1: -43.1577,
    y1: 14.1187,
    x2: 109.443,
    y2: 97.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_178_485",
    x1: -39.1344,
    y1: 6.73728,
    x2: 113.466,
    y2: 89.9133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_178_485",
    x1: -36.6401,
    y1: 2.16012,
    x2: 115.96,
    y2: 85.3362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_178_485",
    x1: -33.0628,
    y1: -4.40126,
    x2: 119.536,
    y2: 78.7748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_178_485",
    x1: -29.7986,
    y1: -10.3899,
    x2: 122.8,
    y2: 72.7861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.6654,
    height: 90.6654,
    fill: "white",
    transform: "translate(0.603149 0.487305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab98b73bbe5a2ee0f9bac9f6081c99b2.svg";
export { ForwardRef as ReactComponent };